import { Icon } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { Card } from '@/components_deprecated/Card'
import { useModuleConfigs } from '@/modules/companies/CompanySettings/hooks'
import React from 'react'
import { Link } from 'react-router'
import styled from 'styled-components'
import { usePermissions } from '@/utils/hooks'
import { PERMISSIONS } from '@/utils/permissions'

const Wrapper = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;

  ${props => props.theme.media.custom({ max: '1280px' })} {
    height: auto;
  }
`
const List = styled(Card)`
  display: flex;
  flex-direction: column;
  min-width: min-content;
  height: 100%;
  padding: 0;

  overflow: hidden;
  background: white;
`
const Item = styled(Link)`
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 1.6em 0;
  min-width: min-content;

  font-size: 1.4em;
  color: ${props => props.theme.colors.text.dark};
  font-weight: 600;
  white-space: nowrap;

  & + a {
    border-top: 1px solid ${props => props.theme.colors.gray8};
  }

  i {
    color: ${props => props.theme.colors.gray5};
    transition: transform ease-out 0.2s;
    padding-left: 1rem;
  }
  &:hover {
    text-decoration: none;
    background: ${props => props.theme.colors.quaternary};
    color: ${props => props.theme.colors.secondary};

    i {
      transform: translateX(8px);
      color: ${props => props.theme.colors.secondary};
    }
  }

  ${props => props.theme.media.custom({ max: '1280px' })} {
    min-height: 6.5rem;
  }
  ${props => props.theme.media.mobile} {
    padding: 1.6em;

    font-size: 1.2em;
  }
`

interface DashboardControlProps {}

export const DashboardControl: React.FC<DashboardControlProps> = () => {
  const translations = useTranslate({
    stoppedForInspection: 'users.stopped-in-control',

    activities: 'documentation.drive-and-rest-time',
    infringements: 'common.infringements',
    handbook: 'documentation.documentation-for-control',
  })

  const { active } = useModuleConfigs()
  const { hasPermissions } = usePermissions()

  const showInfringements =
    active.infringements &&
    hasPermissions(PERMISSIONS.infringements.view.infringement)

  return (
    <Wrapper>
      <h2>{translations.stoppedForInspection}</h2>

      <List>
        <Item to="/activities">
          {translations.activities}
          <Icon icon="chevron-right" type="light" />
        </Item>

        {showInfringements && (
          <Item to="/infringements">
            {translations.infringements}
            <Icon icon="chevron-right" type="light" />
          </Item>
        )}

        {active.handbook && (
          <Item to="/handbook">
            {translations.handbook} <Icon icon="chevron-right" type="light" />
          </Item>
        )}
      </List>
    </Wrapper>
  )
}
